const INSERT_INSTAGRAM_BUTTON = "insert-instagram-button";
const INSERT_TWITTER_BUTTON = "insert-twitter-button";
const INSERT_PINTEREST_BUTTON = "insert-pinterest-button";
const INSERT_FACEBOOK_BUTTON = "insert-facebook-button";
const INSERT_TIKTOK_BUTTON = "insert-tiktok-button";
const SOCIAL_EMBED_MODAL = "social-embed-upload-modal";
const SOCIAL_EMBED_MODAL_INPUT = "social-embed-upload-modal-input";
const SOCIAL_EMBED_MODAL_SUBMIT_BTN = "action-button-save";
const LINK_PREVIEW_VIEWER = "link-preview-viewer";
const PLUGIN_TOOLBAR_REPLACE_TO_LINK_BUTTON = "plugin-toolbar-replace-to-link-button";
const PLUGIN_TOOLBAR_LINK_BUTTON = "plugin-toolbar-link-button";
export {
  INSERT_FACEBOOK_BUTTON,
  INSERT_INSTAGRAM_BUTTON,
  INSERT_PINTEREST_BUTTON,
  INSERT_TIKTOK_BUTTON,
  INSERT_TWITTER_BUTTON,
  LINK_PREVIEW_VIEWER,
  PLUGIN_TOOLBAR_LINK_BUTTON,
  PLUGIN_TOOLBAR_REPLACE_TO_LINK_BUTTON,
  SOCIAL_EMBED_MODAL,
  SOCIAL_EMBED_MODAL_INPUT,
  SOCIAL_EMBED_MODAL_SUBMIT_BTN
};
//# sourceMappingURL=data-hooks.js.map
